import ProductCard from "components/Product/ProductCard"
import ProductList from "components/Product/ProductList"

import "components/ShoppableImage/ShoppableImage.css"

import Typeahead from "components/Typeahead/Typeahead"
import { observer } from "mobx-react"
import queryString from "qs"
import React from "react"
import { Link, withRouter } from "react-router-dom"
import { Button, Card, Container, Form, Grid, Header, Icon, Image, Menu, Modal, Segment } from "semantic-ui-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore"
import productStore from "stores/productStore"
import imageStore, { EImage, Tag } from "./imageStore"

import Price from "components/Price/Price"

const BASE = shop.config.BASE

@observer
class ImageContainer extends React.Component {

  state = {
    usePreview: false
  }

  componentDidMount() {
    const slug = this.props.slug
    imageStore.getBySlug( slug )
    // imageStore.addImage( id, new EImage( { id } ) )
  }

  togglePreview = () => {
    this.setState( { usePreview: !this.state.usePreview } )
  }

  toCart = () => {
    const eImage = imageStore.bySlug.get( this.props.slug )
    console.log( { eImage } )

    if ( eImage ) {
      eImage.products.forEach( p => {
        const product = productStore.productById.get( p.productId )
        if ( !product ) return false
        if ( !product.count ) {
          product.count = 1
        } else {
          product.count++
        }
        shop.cart.add( product )
      } )
    }

    shop.toast( `${eImage.title} (${eImage.products.length} Positionen) in den Warenkorb gelegt`, "success", false, "bottom" )
  }

  render() {
    const { useEditor } = cmsStore
    const eImage = imageStore.bySlug.get( this.props.slug )
    if ( !eImage ) return null
    return <div className=" pv4 pb6">
      <Container>
        <div className="fr">
          {/*<Button icon={"sticky note"} title={"Alle Artikel merken"}/>*/}
          {shop.session && <Button onClick={this.toCart} primary title={"Alle Artikel in den Warenkorb"}><Icon name="shopping cart"/> Alle Artikel</Button>}
        </div>
        <h2><Button basic circular as={Link} to={`/bildwelt/${eImage.category}`} icon={"chevron left"}/> {eImage.title}</h2>

        {!useEditor && <Epic image={eImage}/>}
        {useEditor && <EpicEditor image={eImage}/>}
      </Container>
      {shop.session && <div className="pv5 bg-silver">
        <div className="tc">
          <p>Mit einem Klick alle Produkte dieser Bildwelt in den Warenkorb legen</p>
          <Button onClick={this.toCart} primary title={"Alle Artikel in den Warenkorb"}><Icon name="shopping cart"/> Alle Artikel</Button>
          {/*<Button icon={"sticky note"} title={"Alle Artikel merken"}/>*/}
        </div>
      </div>}

      {!shop.session && <div className="pv5 bg-silver">
        <div className="tc">
          <p>Anmelden um Preise und Details zu erhalten.</p>
          <Button as={Link} to={`/login?referrer=${location.pathname}`} primary title={"Anmelden"}>Anmelden</Button>
          {/*<Button icon={"sticky note"} title={"Alle Artikel merken"}/>*/}
        </div>
      </div>}

    </div>
  }
}

@observer
class TagForm extends React.Component {
  state = {}

  handleChange = ( e, { value } ) => {
    const { image } = this.props
    this.setState( { value } )
    image.post()
  }

  componentDidMount() {
    let { tag } = this.props
    if ( tag ) {
      if ( tag.productId ) productStore.get( tag.productId )
      // console.log("LOADING PRODUCT", tag.productId)
    }
  }

  handleProduct = ( { product } ) => {
    let { tag, image } = this.props
    // console.log({product})
    tag.productId = product.map_id
    productStore.get( tag.productId )
    this.forceUpdate()
  }

  handleDelete = ( product ) => {
    const { image } = this.props
    image.removeTag( product )
    image.post()
  }

  render() {
    const { tag } = this.props
    const product = productStore.productById.get( tag.productId )
    return (
      <Form>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Header inverted>Wähle ein Produkt</Header>
              <Typeahead
                defaultValue={tag.productId}
                onSelect={this.handleProduct}
                fluid label="Article Id"/>
              {/*<pre>{JSON.stringify(tag, null, 2)}</pre>*/}
              {/*<Form.TextArea label="About" placeholder="Tell us more about you..." />*/}

            </Grid.Column>
            <Grid.Column>
              <Header inverted>Vorschau</Header>
              <Card.Group itemsPerRow={1} className="justify-end">
                {product && <ProductCard product={product}/>}
              </Card.Group>
              {!product && <div>PRODUKT WÄHLEN</div>}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <div className="pt3 ph2 overflow-hidden tr">
              <Button
                as={Link}
                to={{ search: "" }}
                state={{ preventScrollToTop: true }}
                basic icon={"trash"} onClick={() => {
                this.handleDelete( tag )
              }} color={"red"}/>
              <Button
                as={Link}
                to={{ search: "" }}
                state={{ preventScrollToTop: true }}
                primary
                onClick={this.handleChange}
              >OK</Button>
            </div>
          </Grid.Row>
        </Grid>

      </Form>
    )
  }
}


@withRouter
@observer
class EpicEditor extends React.Component {

  state = {
    aspect: 16 / 9
  }

  handleLoad = ( e ) => {
    let $img = e.target
    const { width, height } = $img
    const aspect = width / height
    // console.log("WIDTH", {width, height})
    this.setState( { aspect, width, height } )
  }

  handleClick = ( e ) => {
    const { image } = this.props
    if ( this.__dismissNextClickEvent ) {
      this.__dismissNextClickEvent = false
      return
    }

    let tag = new Tag( `${Math.random().toString( 32 )}` )
    this.placeTagByEvent( e, tag )
    image.addTag( tag )
  }

  getDomNode() {
    const $el = document.querySelector( "#ShoppableImage-Container" )
    if ( !$el ) throw(new Error( "Couldn't find #ShoppableImage-Container" ))
    return $el
  }

  placeTagByEvent( e, tag ) {

    const $el = this.getDomNode()
    const w = $el.offsetWidth
    const h = $el.offsetHeight

    // get this after styling :) TODO load at runtime
    const containerWidth = 44
    const containerHeight = 44

    let x = e.nativeEvent.offsetX - 0.5 * containerWidth
    let y = e.nativeEvent.offsetY - 0.5 * containerHeight

    this.placeTag( tag, x, y, w, h )
  }

  placeTag( tag, xPixel, yPixel, w, h ) {
    const x = `${xPixel / w * 100}`
    const y = `${yPixel / h * 100}`
    tag.place( { x, y } )
  }

  onDragStart = ( e, tag ) => {
    // console.log("onDragStart", tag)
    this.lastDraggedItem = tag
  }

  onDragOver = ( e ) => {
    // console.log("onDragOver")
    e.preventDefault()
  }

  onDrop = ( e ) => {
    const { image } = this.props
    let tag = this.lastDraggedItem
    console.log( "onDrop", tag )
    this.placeTagByEvent( e, tag )
    image.post()
    e.preventDefault()
  }

  handleError = ( e ) => {
    // console.log("EPIC: ERROR", e)
  }

  render() {

    const { image } = this.props
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const editTag = query.tag
    const { img, tagById } = image
    const { aspect } = this.state
    const tags = [...tagById.entries()].map( e => e[ 1 ] )
    const tag = tagById.get( editTag )

    return (
      <div className="ShoppableImage EpicEditor">
        <div
          className="img-container relative cover droppable"
          onDragOver={this.onDragOver}
          onDrop={this.onDrop}
          id={"ShoppableImage-Container"}
          onClick={this.handleClick}
          style={{
            height         : 0,
            paddingBottom  : `${1 / aspect * 100}%`,
            width          : "100%",
            backgroundImage: `url(${img})`
          }}>
          {tags.map( tag => {
              const { top, left, id } = tag
              return <Button
                className="absolute draggable HoverButton"
                as={Link}
                to={{ search: `?tag=${id}` }}
                onClick={() => {
                  this.__dismissNextClickEvent = true
                }}
                draggable
                onDragStart={e => this.onDragStart( e, tag )}
                title={`#${id} `}
                key={id}
                circular
                style={{ top, left }}>
                <Icon name={"tag"}/>
                <ProductTag id={tag.productId}/>
              </Button>
            }
          )}
        </div>

        <div className="editor">
          <Menu>
            <Menu.Item><Segment inverted compact loading={image.loading} color={"green"}><Icon name="check"/> Gespeichert</Segment></Menu.Item>
            <Menu.Item position={"right"}><Button as={Link} target={"_blank"} to={`${shop.config.BASE}/wp/wp-admin/post.php?post=${image.id}&action=edit`} primary>BILD
              ÄNDERN</Button></Menu.Item>
          </Menu>
        </div>

        {tag && <Modal open basic>
          <Modal.Content>
            <TagForm tag={tag}
                     tagId={tag.id}
                     image={image}/>
          </Modal.Content>
        </Modal>}

        {/*HANDLE LOAD EVENTS */}
        <div className="dn">
          <Image
            onLoad={this.handleLoad}
            onError={this.handleError}
            src={image.img}/>
        </div>

        <div className="pv3">
          <ProductList
            title={"Artikel im Bild"}
            list={tags.map( tag => tag.productId )}
            repeat={ProductCard}/>
        </div>

        {/*<div className="pb3 pt4">*/}
        {/*<h2 className="fw2"> Ähnliche Artikel </h2>*/}
        {/*<Card.Group itemsPerRow={4}>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*</Card.Group>*/}
        {/*</div>*/}
      </div>
    )
  }
}

@observer
class ProductLoader extends React.Component {

  state = {
    product: null,
    error  : null
  }

  componentDidMount() {
    const { id } = this.props
    const product = productStore.productById.get( id )
    if ( product ) return

    productStore.get( id )
      .then( product => {
        this.setState( { product } )
      } ).catch( err => {
      this.setState( { error: "Nicht verfügbar" } )
    } )
  }

  render() {
    const { id } = this.props
    const product = productStore.productById.get( id )
    const RenderComponent = this.props.as
    if ( !product ) return <Button loading/>
    return <div><RenderComponent style={{width:"100%"}} product={product}/></div>
  }
}


class HoverButton extends React.Component {

  render() {
    const { tag, to, title, style, active } = this.props


    return (
      <React.Fragment>
        <div className="HoverButton-container absolute" style={style}>
          <Button
            active={active}
            className={"HoverButton"}
            as={Link}
            to={active ? "./" : to}
            title={title}
            circular>
            <Icon name="tag"/>
            <ProductTag id={tag.productId}/>
          </Button>
        </div>
      </React.Fragment>
    )
  }
}


@observer
class ProductTag extends React.Component {

  render() {
    const product = productStore.productById.get( this.props.id )
    if ( !product ) return null
    return <div className="ProductTag">
      <div className="f6">#{product.map_id}</div>
      <div className="f6 b"><Price>{product.price}</Price></div>
    </div>
  }
}


@withRouter
@observer
class Epic extends React.Component {

  state = {
    aspect: 16 / 9,
    node  : false
  }

  handleLoad = ( e ) => {
    let $img = e.target
    const { width, height } = $img
    const aspect = width / height
    this.setState( { aspect, width, height } )
  }

  onDragStart = ( e, tag ) => {
    // console.log("onDragStart", tag)
    this.lastDraggedItem = tag
  }

  onDragOver = ( e ) => {
    // console.log("onDragOver")
    e.preventDefault()
  }

  onDrop = ( e ) => {
    let tag = this.lastDraggedItem
    if ( e.preventDefault ) {
      e.preventDefault();
    }
    if ( e.stopPropagation ) {
      e.stopPropagation();
    }
    // console.log("onDrop", tag)
  }

  handleError = ( e ) => {
    // console.log("EPIC: ERROR", e)
  }


  render() {

    const { location, image } = this.props
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const editTag = query.tag
    const { img, tagById } = image
    const { aspect, node } = this.state
    const tags = [...tagById.entries()].map( e => e[ 1 ] )
    const tag = tagById.get( editTag )
    // console.log({tags})

    return (
      <div className="ShoppableImage ">
        <div className="cf">
          <Grid stackable doubling style={{width: "100%"}}>
            <Grid.Row>
              <Grid.Column width={12}>
                <div
                  className="img-container relative cover droppable "
                  onDragOver={this.onDragOver}
                  onDrop={this.onDrop}
                  id={"ShoppableImage-Container"}
                  onClick={this.handleClick}
                  style={{
                    height         : 0,
                    paddingBottom  : `${1 / aspect * 100}%`,
                    width          : "100%",
                    backgroundImage: `url(${img})`
                  }}>
                  {tags.map( tag => {
                      const { top, left, id } = tag
                      return <HoverButton
                        active={editTag === tag.id}
                        context={node}
                        tag={tag}
                        to={{ search: `?tag=${id}` }}
                        title={tag.productId}
                        key={id}
                        icon="tag"
                        circular
                        style={{ top, left }}/>
                    }
                  )}
                </div>
              </Grid.Column>
              <Grid.Column width={4}>
                <div className={"w-auto"}>
                  {tag && <div>
                    <ProductLoader  id={tag.productId} as={ProductCard}/>
                  </div>}
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>

        {/*<div className="editor">*/}
        {/*<Menu attached={"top"}>*/}
        {/*/!*<Menu.Item><Button primary>PRODUKT HINZUFÜGEN</Button></Menu.Item>*!/*/}
        {/*<Menu.Item position={"right"}><Button primary icon={"shopping cart"}/></Menu.Item>*/}
        {/*</Menu>*/}
        {/*</div>*/}

        {/*{tag && <Modal*/}
        {/*basic*/}
        {/*open*/}
        {/*size="fullscreen"*/}
        {/*closeOnDocumentClick*/}
        {/*onClose={() => {*/}
        {/*this.props.history.replace( this.props.location.pathname )*/}
        {/*}}*/}
        {/*>*/}
        {/*<div className="fixed top-2 left-2">*/}
        {/*<Button circular basic inverted as={Link} to={this.props.location.pathname} icon="close"/>*/}
        {/*</div>*/}
        {/*<Modal.Content>*/}
        {/*<ProductList*/}
        {/*center*/}
        {/*list={[ tag.productId ]}*/}
        {/*repeat={ProductCard}/>*/}
        {/*<div className="pt2 tc ">*/}
        {/*/!*<Button.Group>*!/*/}
        {/*/!*<Button as={Link} to={this.props.location.pathname} icon="close"/>*!/*/}
        {/*/!*<Button icon={"chevron left"}/>*!/*/}
        {/*/!*<Button icon={"chevron right"}/>*!/*/}
        {/*/!*</Button.Group>*!/*/}
        {/*</div>*/}
        {/*</Modal.Content>*/}
        {/*</Modal>}*/}

        {/*HANDLE LOAD EVENTS */}
        <div className="dn">
          <Image
            onLoad={this.handleLoad}
            onError={this.handleError}
            src={image.img}/>
        </div>


        <div className="pv3">
          <ProductList
            title={"Artikel im Bild"}
            list={tags.map( tag => tag.productId )}
            repeat={ProductCard}/>
        </div>

        {/*<div className="pb3 pt4">*/}
        {/*<h2 className="fw2"> Ähnliche Artikel </h2>*/}
        {/*<Card.Group itemsPerRow={4}>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*</Card.Group>*/}
        {/*</div>*/}

      </div>
    )
  }
}

@withRouter
export default class ShoppableImage extends React.Component {

  render() {
    const query = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    const editTag = query.tag
    const { slug } = this.props.match.params

    return <div className="">
      <ImageContainer editTag={editTag} slug={slug}/>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/ShoppableImage/ShoppableImage.js